// Иконка корзины в шапке клиентского портала (D14 §7).
// Badge показывает число позиций (lines.length) — не units, чтобы UX совпадал
// с маркет-плэйсами (5 различных SKU = «5», а не «25 единиц»).
// Если контекст TT не выбран — клик ведёт на /cart, страница сама покажет
// «Выберите торговую точку» banner.
import { ShoppingCart } from 'lucide-react'
import { Link } from '../../lib/router'
import { usePortalCartContext } from './usePortalCartContext'
import { useCart } from './useCart'

export function CartIconButton() {
  const context = usePortalCartContext()
  const tradepointId = context.pointId
  const cart = useCart(tradepointId)
  const count = cart.data?.lines.length ?? 0

  return (
    <Link
      to="/cart"
      className="cart-icon-button"
      aria-label={
        count > 0 ? `Корзина: ${count} позиций` : 'Корзина (пусто)'
      }
      data-testid="cart-icon-button"
    >
      <ShoppingCart size={18} aria-hidden="true" />
      {count > 0 && (
        <span className="cart-icon-button__badge" data-testid="cart-icon-badge">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  )
}
